module.exports = __webpack_public_path__ + "assets/images/project/nongsa.jpg?v=b7648783";